<template>
  <div>
    <div v-if="hasCustomUrl">
      <div
        v-if="isIntegrated"
        class="row"
      >
        <div class="col-12 mb-4">
          <sales-summary-container
            :data-range="dataRange"
            :profile="profile"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-if="isIntegrated"
        class="row"
      >
        <div class="col-12 mb-4">
          <sales-summary-container
            :data-range="dataRange"
            :profile="profile"
            @hasCustomUrl="onCustomUrl"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <base-card>
          <div class="row">
            <div class="col-12">
              <div class="row sticky">
                <div class="col-12">
                  <data-range-selector v-model="dataRange" />
                </div>
              </div>
            </div>
            <div class="col-6">
              <associate-activity-container
                :profile-id="profileId"
                :data-range="dataRange"
                @hasCustomUrl="onCustomUrl"
              />
            </div>
            <div class="col-6">
              <associate-performance-chart-container :data-range="dataRange" />
            </div>
          </div>
        </base-card>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <associate-outreach-list-container
          :profile-id="profileId"
          data-range="12m"
        />
      </div>
    </div>
  </div>
</template>
<script>

import integrable from '@/components/mixins/integrable';
import DataRangeSelector from '@/components/Widgets/Reports/DataRangeSelector';
import AssociateActivityContainer from '@/components/Widgets/AssociateReports/AssociateActivityContainer';
import AssociatePerformanceChartContainer from '@/components/Widgets/AssociateReports/AssociatePerformanceChartContainer';
import AssociateOutreachListContainer from '@/components/Widgets/AssociateReports/AssociateOutreachListContainer';

export default {
  components: {
    DataRangeSelector,
    AssociateActivityContainer,
    AssociatePerformanceChartContainer,
    AssociateOutreachListContainer,
  },
  mixins: [integrable],
  data() {
    return {
      dataRange: this.institutionDefaultDataRange,
      hasCustomUrl: false,
    };
  },
  computed: {
    profileId() {
      return this.$store.state.account.user.profile.pk;
    },
    profile() {
      if (!this.$store.state.account.user.profile) {
        return {};
      }
      return this.$store.state.account.user.profile;
    },
    institutionDefaultDataRange() {
      return this.$store.state.account.user.profile.institution.reports_time_range;
    },
  },
  watch: {
    institutionDefaultDataRange: {
      handler(newval) {
        if (newval && !this.dataRange) this.dataRange = newval;
      },
      immediate: true,
    },
  },
  methods: {
    onCustomUrl() {
      this.hasCustomUrl = true;
    },
  },
};
</script>
<style lang="scss"
  scoped>
.sticky {
  position: sticky;
  position: -webkit-sticky;
  /* Safari */
  top: 60px;
  z-index: 10;
}
</style>
